<ziq-use-allowance-select [hidden]="!visibilityOptions.showUseAllowance" [use]="use.value" [model]="use"
    [useAllowances]="useAllowances" [currentTab]="currentTab"
    [attributePopupTitleDetails]="attributePopupTitleDetails + ' - Use Allowance'"
    [hideAttributeButtons]="hideAttributeButtons" [propertyName]="'AllowedUsesId'" [readOnly]="readOnly">
</ziq-use-allowance-select>

<ziq-number-value-field [hidden]="!visibilityOptions.showUseLimit" [model]="use" [currentTab]="currentTab"
    [propertyName]="'UseLimit'" [tableFieldId]="use.value.currentState.CalibrationUsesLabelId"
    [tableFieldOption]="tableFieldOption.USE_LIMIT"
    [attributePopupTitleDetails]="attributePopupTitleDetails + ' - Use Limit'"
    [hideAttributeButtons]="hideAttributeButtons" [readOnly]="readOnly"></ziq-number-value-field>

<ziq-number-value-field [hidden]="!visibilityOptions.showParkingRequired" [model]="use" [currentTab]="currentTab"
    [propertyName]="'ParkingRequired'" [tableFieldId]="use.value.currentState.CalibrationUsesLabelId"
    [tableFieldOption]="tableFieldOption.PARKING_REQUIRED"
    [attributePopupTitleDetails]="attributePopupTitleDetails + ' - Parking Required'"
    [hideAttributeButtons]="hideAttributeButtons" [readOnly]="readOnly"></ziq-number-value-field>
